import Base from "./base.js"

export default class AfterTest extends Base {
  constructor(Vue, store) {
    super("socket-init", Vue, store)
  }

  after(to, from) {
    this.vm.prototype.$socket.init()
  }
}
